import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SharedService } from "./../../shared/shared.service";
import { DevoteeDetail } from "./../devotee-detail";
import { DevoteeService } from "./../devotee.service";

@Component({
  selector: 'app-devotee-dashboard',
  templateUrl: './devotee-dashboard.component.html',
  styleUrls: ['./devotee-dashboard.component.css']
})
export class DevoteeDashboardComponent implements OnInit {

  constructor(private sharedService: SharedService,
    private domSanitizer: DomSanitizer,
    private devoteeService:DevoteeService) { }

  devoteeDetail: DevoteeDetail;
  safeUrl: SafeUrl;
  ngOnInit() {
    this.devoteeDetail = this.sharedService.getDevoteeDataAtLocStorage();
    
    this.safeUrl = this.domSanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/6Bzg4A-DxSM");
    
    console.log("dashboard loaded");
  }

}



// WEBPACK FOOTER //
// ./src/app/devotee/devotee-dashboard/devotee-dashboard.component.ts